module.exports = __webpack_public_path__ + "static/media/parceiro_fundoambiental.1f8742b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parceiro_fundoambiental.svg
// module id = 161
// module chunks = 0